
const wrapper = document.querySelector('.wrapper');
const header = document.querySelector('.header');
const main = document.querySelector('main.main');

const wrapperClasses = {
  nyrdc: 'nyrdc-wrapper',
  internal: 'internal'
};

function setMainMargin() {
  if (!wrapper.classList.contains(wrapperClasses.nyrdc)) {
    return false;
  }

  if (header) {
    let margin_top = header.offsetHeight;
    main.style.marginTop = `${margin_top}px`;
  }

}

// comment out for now on Gin theme
// document.addEventListener("DOMContentLoaded", setMainMargin);
